import * as React from "react";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
const PostalCode = ({ label, errorMessage, ...rest }) => /* @__PURE__ */ React.createElement(
  ConnectedFormControl,
  {
    ...ConnectedFormControl.defaultProps,
    id: "postalCode",
    "data-t": "postal-code",
    label,
    errorMessage,
    ...rest
  }
);
export {
  PostalCode as default
};
//# sourceMappingURL=PostalCode.js.map
